import * as React from "react";
import type { SVGProps } from "react";
const SvgEmail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    fillRule="evenodd"
    clipRule="evenodd"
    imageRendering="optimizeQuality"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    viewBox="0 0 186.26 186.26"
    {...props}
  >
    <path
      fillRule="nonzero"
      d="M39.35 8.47h107.56c8.49 0 16.22 3.5 21.81 9.08l.24.26c5.44 5.58 8.83 13.22 8.83 21.55v107.55c0 8.49-3.49 16.22-9.07 21.81-5.59 5.58-13.32 9.07-21.81 9.07H39.35c-8.49 0-16.22-3.49-21.81-9.07-5.58-5.59-9.07-13.32-9.07-21.81V39.36c0-8.46 3.49-16.2 9.08-21.8 5.58-5.59 13.31-9.09 21.8-9.09zM19.64 44.51l59.54 59.54c3.83 3.83 8.89 5.74 13.95 5.74 5.06 0 10.12-1.91 13.95-5.74l59.54-59.54v-5.15c0-5.32-2.12-10.17-5.54-13.7l-.25-.22c-3.55-3.56-8.5-5.8-13.92-5.8H39.35c-5.42 0-10.37 2.24-13.92 5.8a19.585 19.585 0 0 0-5.79 13.92v5.15zm146.98 15.76-51.65 51.66c-6.02 6.02-13.95 9.03-21.84 9.03-7.89 0-15.82-3.01-21.84-9.03L19.64 60.27v86.64c0 5.42 2.23 10.37 5.79 13.92 3.55 3.56 8.5 5.79 13.92 5.79h107.56c5.42 0 10.37-2.23 13.92-5.79 3.56-3.55 5.79-8.5 5.79-13.92V60.27z"
      className="fil0"
    />
  </svg>
);
export default SvgEmail;
